export { default as wrapRootElement } from './src/state/reduxWrapper';

export function shouldUpdateScroll(prevRouterProps, { location }) {
  const view = document.getElementById('view')
  view.scrollTop = 0
}